<template>
    <div class="index">
      <el-tabs v-model="searchForm.activeName" @tab-click="handleClick" >
        <el-tab-pane label="设备信息" name="1" v-if="deviceData" >
          <el-row >
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader" >基础信息</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >设备编号</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.deviceId}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >设备名称</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.name}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >微信设备ID</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.wxDeviceId}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >设备备注</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.remarks}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >安装位置</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.addr}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >安装详细地址</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.addrDetail}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader"  ></el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >运行状态</el-col>
                <el-col :span="16" class="itemVal" >
                  <span v-if="deviceData.online==0" >不在线</span>
                  <span v-if="deviceData.online==1" >在线</span>
                </el-col>
              </el-row>
              <el-row v-if="deviceData && deviceData.heartbeatTime" >
                <el-col :span="8" class="itemName" >最后心跳时间</el-col>
                <el-col :span="16" class="itemVal" >{{deviceData.heartbeatTime}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >设备用途</el-col>
                <el-col :span="16" class="itemVal" v-if="deviceData.useType==0" >校外</el-col>
                <el-col :span="16" class="itemVal" v-if="deviceData.useType==1" >校内</el-col>
              </el-row>
            </el-col>
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader" ><span v-if="isShowAddDeviceBtn">设备操作</span></el-col>
              </el-row>
              <el-row >
                <el-col >
                  <div class="operateDiv" v-if="isShowAddDeviceBtn" >
                      <el-row >
                        <el-col :span="8" class="operateItem" >
                          <div style="cursor: pointer;" @click="showWifiDlg()" >
                            <img :src="require('@/assets/img/deviceIcon/icon-wifi.png')" style="width: 24px;"  >
                            <div class="operateName"   >连接WIFI</div>
                          </div>
                        </el-col>
                        <el-col :span="8" class="operateItem" >
                          <div style="cursor: pointer;" @click="showSipDlg()" >
                            <img :src="require('@/assets/img/deviceIcon/icon-sip.png')" style="width: 24px;" >
                            <div class="operateName" >SIP账号</div>
                          </div>
                        </el-col>
                        <el-col :span="8" class="operateItem" >
                          <div style="cursor: pointer;" @click="showVolumeWin"  >
                            <img :src="require('@/assets/img/deviceIcon/icon-volume.png')" style="width: 24px;" >
                            <div class="operateName" style="color: #589EF8;" >音量设置</div>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row >
                        <el-col :span="8" class="operateItem" >
                          <div style="cursor: pointer;" @click="showUpgradeWin"  >
                            <img :src="require('@/assets/img/deviceIcon/icon-upgrade.png')" style="width: 24px;" >
                            <div class="operateName" >升级App</div>
                          </div>
                        </el-col>
                        <el-col :span="8" class="operateItem" >
                          <div style="cursor: pointer;"  @click="gotoReboot"  >
                            <img :src="require('@/assets/img/deviceIcon/icon-restart.png')" style="width: 24px;" >
                            <div class="operateName" >重启设备</div>
                          </div>
                        </el-col>
                        <el-col :span="8" class="operateItem" >
                          <template v-if="delisting" >
                            <div style="cursor: pointer;" @click="enableDevice" >
                              <img :src="require('@/assets/img/deviceIcon/icon-disable.png')" class="gray transform180" style="width: 24px;" >
                              <div class="operateName gray" style="color: #fcba6f;" >上线设备</div>
                            </div>
                          </template>
                          <template v-if="delisting==false" >
                            <div style="cursor: pointer;" @click="disableDevice" >
                              <img :src="require('@/assets/img/deviceIcon/icon-disable.png')" style="width: 24px;" >
                              <div class="operateName" style="color: #fcba6f;" >下线设备</div>
                            </div>
                          </template>
                        </el-col>
                      </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader" >联网信息</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >在线状态</el-col>
                <el-col :span="8" class="itemVal" >
                  <span v-if="deviceData.online==0" >不在线</span>
                  <span v-if="deviceData.online==1" >在线</span>
                </el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >入网方式</el-col>
                <el-col :span="8" class="itemVal" >
                  <span v-if="deviceData.netType=='wifi'||deviceData.netType=='WIFI'" >WIFI</span>
                  <span v-else-if="deviceData.netType=='4g'||deviceData.netType=='4G'" >4G</span>
                  <span v-else-if="deviceData.netType=='line'" >网线</span>
                  <span v-else >--</span>
                </el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >WIFI-SSID</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.curWifiSsid?deviceData.curWifiSsid:'--'}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >物联网卡号</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.iotCardNum?deviceData.iotCardNum:'--'}}</el-col>
              </el-row>
            </el-col>
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader" >SIP信息</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >SIP账号</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.sipAccount}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >SIP密码</el-col>
                <el-col :span="8" class="itemVal" >--</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >微信通话时长</el-col>
                <el-col :span="8" class="itemVal" >{{toMinuteStr(deviceData.callMLen)}}/{{toMinuteStr(deviceData.callLen)}}（分钟）</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >使用线路</el-col>
                <el-col :span="8" class="itemVal" >--</el-col>
              </el-row>
            </el-col>
            <el-col :span="8" >
              <el-row >
                <el-col :span="24" class="tabHeader" >系统信息</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >OS类型</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.osType?deviceData.osType:'--'}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >OS版本号</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.osVn?deviceData.osVn:'--'}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >App版本号</el-col>
                <el-col :span="8" class="itemVal" >{{deviceData.appVn?deviceData.appVn:'--'}}</el-col>
              </el-row>
              <el-row >
                <el-col :span="8" class="itemName" >摄像状态</el-col>
                <el-col :span="8" class="itemVal" >
                  <span v-if="deviceData.online==0" >未启用</span>
                  <span v-if="deviceData.online==1" >启用中</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="运行日志" name="2" >
          <el-form :inline="true" size="mini">
            <el-form-item label="唤醒方姓名/ID/电话/紧急联系人电话">
                <el-input v-model="searchForm.initiator" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="唤醒时间">
              <GetDate ref="GetDate" title="" @getDate="changeSearchFormDate('dateRect', $event)" ></GetDate>
            </el-form-item>
            <el-form-item label="行为方式">
              <el-select v-model="searchForm.act" placeholder="请选择行为方式" style="width: 150px;">
                <el-option label="全部" value=""></el-option>
                <el-option label="发送留言" value="30"></el-option>
                <el-option label="收听留言" value="40"></el-option>
                <el-option label="微信电话" value="10"></el-option>
                <el-option label="语音电话" value="20"></el-option>
                <el-option label="加好友" value="50"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对方姓名/ID/电话/紧急联系人电话">
                <el-input v-model="searchForm.receiver" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="doSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="doReset">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="dataArea" style="margin-top: 15px;">
            <el-table :data="tableData" size="mini" >
                <el-table-column prop="wakenTime" label="唤醒时间" width="135" ></el-table-column>
                <el-table-column prop="wakenName" label="唤醒方姓名" width="120"></el-table-column>
                <el-table-column prop="wakenUserid" label="唤醒方ID" width="150"></el-table-column>
                <el-table-column label="唤醒方电话" width="135">
                  <template scope="temp" >
                    <span >{{filterTelView(temp.row.wakenTel)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="唤醒方紧急联系人电话" width="150">
                  <template  scope="temp" >
                    <span >{{filterTelView(temp.row.wakenContact)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="行为方式" width="120">
                  <template scope="temp" >
                    <span >{{showActName(temp.row.act)}}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="userRole=='admin'" label="现场照片" width="120">
                  <template scope="temp" >
                    <img :src="temp.row.img" style="width: 50px;" @click="showELogImg(temp.row)"  />
                  </template>
                </el-table-column>
                <el-table-column prop="targetName" label="对方姓名" width="120"></el-table-column>
                <el-table-column prop="targetId" label="对方ID" width="150"></el-table-column>
                <el-table-column label="对方电话" width="120">
                  <template  scope="temp" >
                    <span >{{filterTelView(temp.row.targetTel)}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="对方紧急联系人电话" width="150">
                  <template scope="temp" >
                    <span  >{{filterTelView(temp.row.targetContact)}}</span>
                  </template>
                </el-table-column>
            </el-table>
            <Pagination
              style="padding: 0; margin: 0;"
              :total="pageData.total"
              :page.sync="pageData.page"
              :limit.sync="pageData.limit"
              @pagination="paginationQueryPage"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="爱心港信息" name="axg" v-if="deviceData" >
          <el-form :model="deviceData" ref="deviceData" label-width="110px" class="demo-ruleForm" size="mini">
            <el-form-item label="爱心港名称" >
            <el-input placeholder="请输入爱心港名称" v-model="deviceData.loveName" :key="'loveName'+keyLoves" clearable></el-input>
            </el-form-item>
            <el-form-item label="爱心港图标" >
              <el-input type="hidden" placeholder="请输入爱心港照片" v-model="deviceData.loveLogo" :key="'loveLogo'+keyLoves" clearable></el-input>
              <img v-if="deviceData.loveLogo" :src="deviceData.loveLogo" :key="keyLoves" class="logoImgv" />
              <el-upload 
                    :show-file-list="false"
                    action
                    :http-request="goUploadLogo"
                    class="avatar-uploader"
                    list-type="picture-card">
                <el-button type="primary" >上传</el-button>
              </el-upload>
              <el-button type="warning" v-if="this.deviceData.loveLogo" style="float: left; margin-left: 5px ; margin-top: -22px ;" @click="clearLoveLogo" >✕</el-button>
            </el-form-item>
            <el-form-item label="爱心港照片" >
              <el-input type="hidden" placeholder="请输入爱心港照片" v-model="deviceData.loveImgs" :key="keyLoves" clearable></el-input>
              <div v-if="loveImgs!=null && loveImgs.length>0 " class="loveImgv" >
                <div v-for="(imgSrc, index) in loveImgs " :key="index" class="loveImgIts" >
                  <span class="lcb_l" @click="leftLoveImg(index)" >←</span>
                  <span class="lcb_x" @click="removeLoveImg(index)" >✕</span>
                  <img  :src="imgSrc"  />
                </div>
              </div>
              <el-upload 
                    :show-file-list="false"
                    action
                    :before-upload="beforeUploadImgs"
                    :on-change="changeUploadImgs"
                    :http-request="goUploadImgs"
                    class="avatar-uploader"
                    list-type="picture-card">
                <el-button type="primary" >上传</el-button>
              </el-upload>
            </el-form-item>



            <el-form-item label="爱心大使" >
            <el-input placeholder="请输入爱心大使姓名" v-model="deviceData.loveUser" :key="keyLoves" clearable></el-input>
            </el-form-item>
            <el-form-item label="爱心港联系电话" >
            <el-input placeholder="请输入爱心港联系电话" v-model="deviceData.loveMobile" :key="keyLoves" clearable></el-input>
            </el-form-item>
            <el-form-item label="爱心港地址" >
            <el-input placeholder="请输入爱心港地址" v-model="deviceData.loveAddr" readonly="readonly" :key="keyLoves" clearable></el-input>
            </el-form-item>
            <el-form-item label="" >
              <el-button type="primary" @click="gotoSaveLoves">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <!-- WIFI编辑窗口 -->
      <el-dialog title="为设备设置无线网络模式（WIFI）" :visible.sync="wifiDialogVisible" width="650px" :before-close="handleWifiWinClose" top="1vh" >
        <el-form :model="wifiData" ref="wifiData" label-width="110px"
            class="demo-ruleForm" size="mini">
          <el-form-item label="无线(WIFI)账号" >
          <el-input placeholder="请输入无线热点名称" v-model="wifiData.wifiSsid" clearable></el-input>
          </el-form-item>
          <el-form-item label="无线(WIFI)密码" >
          <el-input placeholder="请输入无线密码" v-model="wifiData.wifiPwd" clearable></el-input>
          </el-form-item>
          <el-form-item label="" >
            无线网络设置注意事项：<br />
            1、设置前请确保设备处于在线状态（网络连接成功）；<br />
            2、设备仅支持连接2.4G网络频段，不支持路由器发出的5G网络频段；<br />
            3、无线账号和密码尽可能简化，避免大小写及特殊符号混编；<br />
            4、保存无线账号和密码后需点击重启设备；<br />
            5、设置重启成功后无线网络设置生效；<br />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveWifiData">保存</el-button>
            <el-button @click="handleWifiWinClose" >取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- SIP编辑窗口 -->
      <el-dialog title="SIP账号" :visible.sync="sipDialogVisible" width="600px" :before-close="handleSipWinClose" top="1vh" >
        <el-form :model="sipData" ref="sipData" label-width="110px"
            class="demo-ruleForm" size="mini">
          <el-form-item label="SIP名称" >
            <el-input placeholder="请输入SIP名称" v-model="sipData.sipName" clearable></el-input>
          </el-form-item>
          <el-form-item label="SIP地址" >
            <el-input placeholder="请输入SIP地址" v-model="sipData.sipAddr" clearable></el-input>
          </el-form-item>
          <el-form-item label="SIP-账号" >
            <el-input placeholder="请输入SIP账号" v-model="sipData.sipAccount" clearable></el-input>
          </el-form-item>
          <el-form-item label="SIP-密码" >
            <el-input placeholder="请输入密码" v-model="sipData.sipPasswd" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveSipData">保存</el-button>
            <el-button @click="handleSipWinClose" >取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 音量编辑窗口 -->
      <el-dialog title="音量设置" :visible.sync="volumeVisible" width="600px" :before-close="handleVolumeWinClose" top="1vh" >
        <el-form :model="sipData" ref="sipData" label-width="110px"
            class="demo-ruleForm" size="mini">
          <el-form-item label="媒体音量" >
            <el-select v-model="volume" filterable placeholder="请选择音量大小" remote
                      reserve-keyword size="small" >
              <el-option v-for="item in volumeMediaOps" :key="item" :label="item" :value="item"></el-option>
            </el-select>
              0-{{volumeMax}}</span><br />            
            <span >媒体音量用来控制语音播报时的音量</span>
          </el-form-item>
          <el-form-item label="通话音量" >
            <el-select v-model="tVolume" filterable placeholder="请选择音量大小" remote
                      reserve-keyword size="small" >
              <el-option v-for="item in volumeTelOps" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            1-{{tVolumeMax}}
            <br />
            <span >通话音量用来控制语音视频通话时的音量</span>
          </el-form-item>
          <el-form-item label="铃声音量" v-if="false" >
            <el-select v-model="rVolume" filterable placeholder="请选择音量大小" remote
                      reserve-keyword size="small" >
              <el-option v-for="item in volumeRingOps" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            1-{{rVolumeMax}}
            <br />
            <span >铃声音量用来控制来电响铃的音量</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="gotoSaveVolume()">保存</el-button>
            <el-button @click="handleVolumeWinClose" >关闭</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="升级APP" :visible.sync="upgradeVisible" width="680px" :before-close="handleUpgradeClose" top="1vh" :close-on-click-modal="false" class="upgradeDlg" >
        <el-tabs v-model="upgradeChannel" @tab-click="handleUpgradeChannelClick" class="upgradeTabs" >
          <el-tab-pane label="蒲公英升级" name="pgy" >
            <el-form :model="changeVersionData" ref="changeVersionData" label-width="110px" class="demo-ruleForm" size="mini">
              <el-form-item v-if="changeVersionData" label="版本编号" >
                <template >{{changeVersionData.version}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="文件大小" >
                <template >{{changeVersionData.fileSize}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="版本描述" >
                <template >{{changeVersionData.description}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="发布时间" >
                <template >{{changeVersionData.created}}</template>
              </el-form-item>
              <el-form-item v-if="upgradeStepInfo" label="更新步骤" >
                <div v-html="upgradeStepInfo" ></div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="goUpgrade('pgy',changeVersionData.version)">更新</el-button>
                <el-button type="primary" @click="goCancelUpgrade('pgy',changeVersionData.version)">取消更新</el-button>
                <el-button @click="handleUpgradeWinClose" >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="平台升级" name="pt" >
            <el-form :model="changeVersionData" ref="changeVersionData" label-width="110px" class="demo-ruleForm" size="mini">
              <el-form-item v-if="changeVersionData" label="版本编号" >
                <template >{{changeVersionData.versionName}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="版本描述" >
                <template >{{changeVersionData.intro}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="发布时间" >
                <template >{{changeVersionData.insertTime}}</template>
              </el-form-item>
              <el-form-item v-if="upgradeStepInfo" label="更新步骤" >
                <div v-html="upgradeStepInfo" ></div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="goUpgrade('pt',changeVersionData.versionName)">更新</el-button>
                <el-button type="primary" @click="goCancelUpgrade('pt')">取消更新</el-button>
                <el-button @click="handleUpgradeWinClose" >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="重新安装" name="reist" >
            <el-form label-width="110px" class="demo-ruleForm" size="mini">
              <el-form-item label="最后心跳" v-if=" deviceData && deviceData.heartbeatTime" >
                <template >{{deviceData.heartbeatTime}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="版本编号" >
                <template >{{changeVersionData.versionName}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="版本描述" >
                <template >{{changeVersionData.intro}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="发布时间" >
                <template >{{changeVersionData.insertTime}}</template>
              </el-form-item>
              <el-form-item v-if="changeVersionData" label="更新进度" >
                <template >{{changeVersionData.insertTime}}</template>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="goUpgrade('pt',changeVersionData.versionName)">重新安装</el-button>
                <el-button @click="handleUpgradeWinClose" >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        
      </el-dialog>
    </div>
  </template>
  <script>
  import AMapLoader from "@amap/amap-jsapi-loader";
  import Pagination from '@/components/Pagination'
  import GetDate from "@/views/components/search/GetDate"
  import { getDeviceDetail, saveDeviceData, getPgyAppVersionList, getPtAppVersionList, setUpgradeVersion, setCancelUpgradeVersion, getCtrlTaskStep, setReboot, getDeviceELogPage, getUserRoleType, saveDeviceVolume, saveLoves, uploadLoveHavenImg } from "@/api/zjdevices.js"
  import { Message } from 'element-ui';
  import {regionList} from '@/utils/regionList.js'
  import loadingImgPath from '@/assets/img/loading.gif';
import { remove } from "nprogress";
  export default {
    components: { Pagination, GetDate },
    data() {
      return {
        searchValue: '', // 地点搜索
        gdmap: null,
        lastMapAddr:"", // 标记地图最后移动地点的位置信息
        deviceData:null, // 设备详情信息
        areaList:[], // 区域信息
        searchForm:{
          online:"", // 在线状态
          deviceId:"", // 
          area: "", // 地址区域
          dateRect: "", // 日期区间
          orderInst:" checked ", // 排序按绑定时间（默认）
          orderWake:"", // 排序按唤醒次数
          activeName: "1" , // 默认显示哪个面板
          initiator: "", // 发起方
          receiver: "", // 接收方
          act: "", // 日志类别
        },
        tableData:[],
        volumeTelOps : [1,2,3,4,5], // 通话音量选项(没有0值，是因为通话音量最小值为1)
        volumeRingOps : [1,2,3,4,5,6,7], // 铃声音量选项(没有0值，是因为设置为0时，会变成勿扰模式)
        volumeMediaOps : [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15], // 媒体音量选项
        pageData:{
          page: 1,
          limit: 20,
          total: 0,
        },
        id: "" , // 信息ID
        userRole: null, // 用户角色
        deviceId: "", // 设备信息ID
        wifiDialogVisible: false, // 是否显示WIFI编辑窗口
        wifiData:{
          id:"",
          wifiSsid: "",
          wifiPwd:"",
        },
        delisting: false, // 产品是否下线
        sipDialogVisible: false, // 是否显示SIP编辑窗口
        volumeVisible:false, // 是否显示声音设置窗口
        volume:"", // 媒体音量大小
        volumeMax: "15", // 媒体音量最大大小
        tVolume:"" , // 通话音量大小
        tVolumeMax:"5", // 通话音量最大大小
        rVolume:"" , // 铃声音量大小
        rVolumeMax:"7", // 铃声音量最大大小
        isShowAddDeviceBtn: false, // 是否显示添加设备按钮(只有区级合伙人或系统管理员才可以添加设备)
        sipData:{
          id:"",
          sipName: "",
          sipAddr: "",
          sipAccount: "",
          sipPasswd:"",
        },
        versions:[], // 版本列表
        upgradeVisible: false, // 是否显示版本升级窗口
        upgradeVn:null, // 指定更新的版本
        changeVersionData:null , // 选择的版本信息
        upgradeStepInfo:null , // APP更新信息
        upgradeIntv:null , // 更新定时器句柄
        loadingImgPath: loadingImgPath, //
        actMap:{ 10:"微信视频", 20:"语音电话", 30:"发送留言", 40:"收听留言", 50:"加好友"  }, // 行为方式（10=weixin/20=tel/30=leavemsg/40=readmsg/50=makefriend）
        upgradeChannel: null, // 选择哪个渠道升级
        keyLoves:0, // 一些强制刷新

        loveImgs:[], // 爱心港照片

      }
    },
    created() {
      this.id = this.$route.query.id;

    },
    mounted() {
      // this.initMap();
      this.areaList = JSON.parse(JSON.stringify(regionList)) // 深拷贝原始数据
      this.getLoginUserRoleTypeOnLoad();
      this.getDeviceDetailData();
      // 查询版本列表
      this.searchPgyVersions();
    },
    methods:{
      initMap() { },
      handleClick(tab, event) {
        if (tab.name == 2) {
          // 运行日志
          this.doSearch();
        }else if (tab.name == "axg") {
          // 运行日志
          this.initMap();
          if(this.deviceData.loveImgs!=null && this.deviceData.loveImgs.indexOf(";")>0 ){
            var urls = this.deviceData.loveImgs.substring(0,this.deviceData.loveImgs.length-1);
            this.loveImgs = urls.split(";");
          }
          this.keyLoves++;
          this.deviceData.loveAddr = this.deviceData.addr;

        }
      },
      doSearch(){
        console.log("doSearch()");
        console.log("searchForm:", this.searchForm);
        this.getDeviceELogPageData();
      },
      doReset(){
        this.searchForm.initiator = "";
        this.searchForm.act = "";
        this.searchForm.receiver = "";
        this.searchForm.dateRect = [];
        this.$refs.GetDate.date = [];

      },
      // 查询分页
      paginationQueryPage(){

      },
      handleWifiWinClose(){
        this.wifiDialogVisible = false;
      },
      // 获取设备详情
      getDeviceDetailData(){
        let that =  this;
        var params = {
          id: this.id
        }
        getDeviceDetail(params).then(function(rdata){
          var rs  = rdata.data;
          console.log("getDeviceDetail--rs",rs);
          if(rs.code==0){
            that.deviceData = rs.data;
            console.log("deviceData",that.deviceData);
            if(that.deviceData!=null&&that.deviceData!=""){
              var volume = that.deviceData.volume;
              if(volume.indexOf("/")>0){
                that.volume = volume.substring(0,volume.indexOf("/"));
                var vTmp = volume.substring(volume.indexOf("/")+1);
                if(vTmp!=""){
                  that.volumeMax = vTmp;
                }
              }
              var tVolume = that.deviceData.tVolume;
              if(tVolume.indexOf("/")>0){
                that.tVolume = tVolume.substring(0,tVolume.indexOf("/"));
                var vTmp = tVolume.substring(tVolume.indexOf("/")+1);
                if(vTmp!=''){
                  that.tVolumeMax = vTmp;
                }
              }
              var rVolume = that.deviceData.rVolume;
              if( rVolume && rVolume.indexOf("/")>0){
                that.rVolume = rVolume.substring(0,rVolume.indexOf("/"));
                var vTmp = rVolume.substring(rVolume.indexOf("/")+1);
                if(vTmp!=''){
                  that.rVolumeMax = vTmp;
                }
              }
            }
            that.delisting = that.deviceData.status==0;
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        })
      },
      // 显示wifi编辑窗口
      showWifiDlg(){
        this.wifiData.id = this.id;
        this.wifiData.wifiSsid = this.deviceData.wifiSsid;
        this.wifiData.wifiPwd = this.deviceData.wifiPwd;
        this.wifiDialogVisible = true;
      },
      // 保存WIFI信息
      saveWifiData(){
        this.wifiData.id = this.id;
        this.wifiData.deviceId = this.deviceData.deviceId;
        var that = this;
        saveDeviceData(this.wifiData).then(function(rdata){
          that.wifiDialogVisible = false;
          console.log("saveDeviceData-rs", rdata);
          var rs = rdata.data;
          if(rs.code==0){
            Message({
              message: "操作成功",
              type: 'success',
              duration: 2 * 1000,
              showClose:true,
            });
            // 操作成功，重新加载数据
            that.getDeviceDetailData();
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        })
      },
      // 显示sip编辑窗口
      showSipDlg(){
        this.sipData.id = this.id;
        this.sipData.sipName = this.deviceData.sipName;
        this.sipData.sipAddr = this.deviceData.sipAddr;
        this.sipData.sipAccount = this.deviceData.sipAccount;
        this.sipData.sipPasswd = this.deviceData.sipPasswd;
        this.sipDialogVisible = true;
      },
      // 保存sip信息
      saveSipData(){
        this.sipData.id = this.id;
        this.sipData.deviceId = this.deviceData.deviceId;
        var that = this;
        saveDeviceData(this.sipData).then(function(rs){
          that.sipDialogVisible = false;
          Message({
            message: "操作成功",
            type: 'info',
            duration: 2 * 1000,
            showClose:true,
          })
        })
      },
      handleSipWinClose(){
        this.sipDialogVisible = false;
      },
      handleVolumeWinClose(){
        this.volumeVisible = false;
      },
      // 设备下线（下架）
      disableDevice(){
        let that = this;
        if(this.deviceData!=null){
          this.$confirm('是否确定将此产品（'+this.deviceData.deviceId+'）下架?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var postdata = {
              id: that.deviceData.id,
              status: 0, // 下架
            }
            postdata.deviceId = that.deviceData.deviceId;
            // 提交操作
            saveDeviceData(postdata).then(function(rs){
              console.log("rs::", rs);
              // 用户点击确定后的操作
              that.$message({
                type: 'success',
                message: '商品下架成功!'
              });
              // 重新加载数据
              that.getDeviceDetailData();
            });
            
          }).catch((e) => {
            console.log(e);
            // 用户点击取消后的操作
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        }else{
          Message({
            message: "数据错误",
            type: 'error',
            duration: 2 * 1000,
            showClose:true,
          })
        }
      },
      // 设备上架
      enableDevice(){
        let that = this;
        var postdata = {
          id: that.deviceData.id,
          status: 1, // 下架
        }
        this.postdata.deviceId = that.deviceData.deviceId;
        // 提交操作
        saveDeviceData(postdata).then(function(rs){
          console.log("rs::", rs);
          // 用户点击确定后的操作
          that.$message({
            type: 'success',
            message: '商品上架成功!'
          });
          // 重新加载数据
          that.getDeviceDetailData();
        });
      },
      // 加载蒲公英版本信息
      searchPgyVersions(){
        let that = this;
        that.versions = null;
        getPgyAppVersionList().then(function(rdata){
          var rs = rdata.data;
          if(rs.code==0){
            // 获取成功
            that.versions = rs.data;
            if(that.versions!=null && that.versions.length>0){
              that.changeVersionData = that.versions[0];
              console.log("that.changeVersionData:", that.changeVersionData);
              that.upgradeVn = that.changeVersionData.version;
            }else{
              that.$message({
                type: 'error',
                message: '很遗憾，未查询到版本信息！'
              });
            }
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        });
      },
      // 加载
      searchPtVersions(){
        let that = this;
        that.versions = null;
        getPtAppVersionList().then(function(rdata){
          var rs = rdata.data;
          if(rs.code==0){
            // 获取成功
            that.changeVersionData = rs.data;
            that.upgradeVn = that.changeVersionData.version;
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        });
      },
      showUpgradeWin(){
        this.upgradeVisible = true;
      },
      showVolumeWin(){
        this.volumeVisible = true;
      },
      // 重启设备
      gotoReboot(){
        let that = this;
        this.$confirm('是否确定重启设备?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var taskId = Date.now().toString(16)+Math.random().toString(16).slice(2);
            var postdata = {
              deviceId: that.deviceData.deviceId,
              id: taskId , // 任务ID
            }
            console.log("postdata", postdata);
            // 提交操作
            setReboot(postdata).then(function(rdata){
              var rs = rdata.data;
              console.log("rs::", rs);
              if(rs.code==0){
                that.$message({
                  type: 'success',
                  message: '重启任务已提交!'
                });
              }else{
                that.$message({
                  type: 'error',
                  message: rs.msg
                });
              }
            });
          }).catch((e) => {
            console.log(e);
            // 用户点击取消后的操作
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
      },
      // 关闭升级窗口
      handleUpgradeClose(){
        this.upgradeVisible = false;
      },
      // 去开始更新(channel:0=蒲公英，1=平台)
      goUpgrade(channel,vn){
        let that = this;
        this.formatStep('');
        if(this.deviceData.appVn == vn ){
          that.$message({
            type: 'warning',
            message: "版本相同，无需更新"
          })
          // return;
        }
        if(this.upgradeIntv==null){
          // 从会话中获取taskId
          // sessionStorage.setItem('upgradeTaskId','abc');
          var taskId = sessionStorage.getItem('upgradeTaskId');
          if( taskId == null || taskId == '' ){
            taskId = Date.now().toString(16)+Math.random().toString(16).slice(2);
            console.log("create--"+taskId);
          }else{
            console.log("exists::"+taskId);
          }
          var params= { id:taskId, deviceId: this.deviceData.deviceId, version: vn, channel: channel  }
          setUpgradeVersion(params).then(function(rdata){
            var rs= rdata.data;
            console.log("setUpgradeVersion-rs:", rs );
            if(rs.code==0){
              sessionStorage.setItem('upgradeTaskId',taskId);
              var progressdata = rs.data;
              console.log("progress:", progressdata );
              if(progressdata.indexOf("#")>0){
                var rsVal = progressdata.substring(0,progressdata.indexOf("#"));
                var stepInfo = progressdata.substring(progressdata.indexOf("#")+1);
                // redisKey_step==AUS:{deviceId}==任务更新过程:{taskId},{version},wait,{time}->start,{time}->download,{time},{size}->install,{time}->finish,{time}->restart,{time}
                that.upgradeStepInfo = that.formatStep(stepInfo);;
                if(rsVal=="task-running"){
                  that.$message({
                    message: "版本更新进行中"
                  })
                }
                // 启动定时器，随时检测更新状态
                if(that.upgradeIntv!=null){
                  window.clearInterval(that.upgradeIntv);
                  that.upgradeIntv = null;
                }
                that.upgradeIntv = window.setInterval(that.checkUpgradeStep,2000);
              }else{
                that.$message({
                  message: msg
                })
              }

            }else{
              // 操作失败，直接提示信息
              that.$message({
                message: rs.msg
              })
            }
          })
          
        }else{
          // 已经存在进行中的任务
          that.$message({
            message: "已经存在进行中的任务"
          })
        }
      },
      // 取消版本升级
      goCancelUpgrade(channel,vn){
        let that = this;
        var params= { deviceId: this.deviceData.deviceId }
        setCancelUpgradeVersion(params).then(function(rdata){
          var rs= rdata.data;
          console.log("setCancelUpgradeVersion-rs:", rs );
          if(rs.code==0){
            sessionStorage.removeItem('upgradeTaskId');
            that.$message({
              message: "版本更新已取消" + ((rs.data==null)?"":("："+rs.data))
            })
            that.upgradeVisible = false;
          }else{
            // 操作失败，直接提示信息
            that.$message({
              message: rs.msg
            });
            that.upgradeVisible = false;
          }
        })
      },
      // 检查更新进度
      checkUpgradeStep(){
        let that =  this;
        var params= {
          deviceId: this.deviceData.deviceId,
          ecmd: "syncUpd"
        }
        getCtrlTaskStep(params).then(function(rdata){
          var rs = rdata.data;
          console.log("progressdata==rs::", rs);
          if(rs.code==0){
            // 调用成功
            var logs = rs.data;
            that.upgradeStepInfo = that.formatStep(logs);
            if(logs.indexOf("restart")>=0){
              // 已经完成，退出
              window.clearInterval(that.upgradeIntv);
              that.upgradeIntv = null;
              sessionStorage.removeItem('upgradeTaskId')
              console.log("完成安装退出");
              // 重新加载设备信息
              that.getDeviceDetailData();
            }
          }
        });
      },
      formatStep(logs){
        if(logs.indexOf(",wait")>0){
          var pre = logs.substring(0,logs.indexOf(",wait"));
          var step = logs.substring(logs.indexOf(",wait")+1);
          var preArr = pre.split(",");
          var stepArr = step.split("->");
          var html = "远程升级中：（请保持设备网络畅通，大约需要5-10分钟）";
          for(var i=0;i<stepArr.length;i++){
            var sTmp = stepArr[i];
            var isLast = (i==stepArr.length-1);
            if( sTmp.indexOf("restart")<0 ){
              // html += "<br />● " + sTmp +" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>" ;
              if(sTmp.indexOf('wait')>=0){
                html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('wait')+5)+"  正在连接设备" + (isLast?" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>":"");
              }
              if(sTmp.indexOf('start,')>=0){
                html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('start,')+6)+"  设备连接成功" + (isLast?" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>":"");
              }
              if(sTmp.indexOf('download,')>=0){
                if(sTmp.indexOf('%')>0){
                  var progress = sTmp.substring(sTmp.indexOf("，"));
                  sTmp = sTmp.substring(0,sTmp.indexOf("，"));
                  html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('download,')+9)+"  正在向设备发送最新版安装包" + progress + (isLast?" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>":"");
                }else{
                  html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('download,')+9)+"  正在向设备发送最新版安装包" + (isLast?" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>":"");
                }
              }
              if(sTmp.indexOf('finish,')>=0){
                html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('finish,')+7)+"  新版本安装中" + (isLast?" <img width=18 style='margin-bottom:-3px' src='"+this.loadingImgPath+"'>":"");
              }
            }else{
              html += "<br />实时进程："+sTmp.substring(sTmp.indexOf('restart,')+8)+"  新版安装成功并重新启动设备<br />升级完毕，请在设备详情页面按Ctrl+F5刷新后查看版本号，确认是否升级成功！" ;
            }
          }
          return html;
        }
        return "";
      },
      // 关闭更新窗口
      handleUpgradeWinClose(){
        let that = this;
        this.upgradeVisible = false;
        // 关闭定时器
        // if(that.upgradeIntv!=null){
        //   window.clearInterval(that.upgradeIntv);
        //   that.upgradeIntv = null;
        //   that.upgradeStepInfo="";
        // }
      },
      // 关闭声音编辑窗口
      handleVolumeWinClose(){
        this.volumeVisible = false;
      },
      // 设备运行日志
      getDeviceELogPageData(){
        console.log("getDeviceELogPageData()");
        var dataArr = null;
        if(this.searchForm.dateRect!=null && this.searchForm.dateRect!="" && this.searchForm.dateRect.length>1){
          dataArr = this.searchForm.dateRect;
        }
        var params= {
          page: this.pageData.page,
          limit: this.pageData.limit,
          initiator: this.searchForm.initiator,
          receiver: this.searchForm.receiver,
          act: this.searchForm.act,
          startDate: dataArr?dataArr[0]:null,
          endDate: dataArr?dataArr[1]:null,
          deviceId: this.deviceData.deviceId,
        }
        console.log("searchForm-params:", params);
        let that = this;
        that.signDeviceLoaded = true;
        getDeviceELogPage(params).then(function(rdata){
          var rs = rdata.data;
          if(rs.code==0){
            let pageData = rs.data;
            console.log("pageData", pageData);
            that.tableData = pageData.records;
            that.pageData.total = pageData.total;
          }else{
            that.$message({
              type: 'error',
              message: rs.msg
            });
          }
        });
      },
      clickLogPan(){
        console.log("clickLogPan()");
      },
      // 选择了日志面板
      changeLogPan(){
        console.log("changeLogPan()");
        this.doSearch();
      },
      showELogImg(row){
        console.log('showELogImg()',row);
        window.open(row.img,'','_blank');
      },
      // 过滤手机号显示
      filterTelView(tel){
        let that = this;
        if(tel && tel.length>10){
          if(tel.length>15){
            return "--";
          }
            // 前3位和后4位显示
            if(that.userRole=="admin"){
                return tel;
            }else{
                var pre = tel.substring(0,3);
                var suf = tel.substring(tel.length-4);
                return pre + "****"+suf;
            }
        }
        return "--";
      },
      getLoginUserRoleTypeOnLoad(){
            let that = this;
            that.isShowAddDeviceBtn=false;
            getUserRoleType().then(function(rs){
            var rdata = rs.data;
            if(rdata.code==0){
                var roleType = rdata.data;
                if(roleType.indexOf("admin")==0){
                    // 超级管理员
                    that.userRole="admin";
                    that.isShowAddDeviceBtn=true;
                }else if(roleType.indexOf("20,")==0){
                    // 市级代理
                    that.userRole="20";
                    that.searchValue = cityName;
                }else if(roleType.indexOf("10,")==0){
                    // 县级、区级代理
                    that.userRole="10";
                    that.isShowAddDeviceBtn=true;
                    that.searchValue = countyName;
                }
            }else{
                that.$message({
                type: 'error',
                message: rdata.msg
                });
            }
            });
        },
        // 
        showActName(act){
          // 行为方式（10=weixin/20=tel/30=leavemsg/40=readmsg/50=makefriend）
          return this.actMap[act];
        },
        // 升级面板选择(蒲公英还是平台)
        handleUpgradeChannelClick(channel){
          console.log("handleUpgradeChannelClick()", channel);
          let that = this;
          // 如果定时任务，如果存在
          if(that.upgradeIntv!=null){
            window.clearInterval(that.upgradeIntv);
            that.upgradeIntv = null;
          }
          that.upgradeStepInfo=""; // 将任务进度置空
          var name = channel.name;
          if(name=="pgy"){
            // 面板中选择了蒲公英
            // 加载蒲公英最新版本信息
            this.searchPgyVersions();
            // 获取下是否有进行中的任务，如果有，打开它
            var taskId = sessionStorage.getItem('upgradeTaskId');
            if( taskId == null || taskId == '' ){
            }else{
              // 有缓存的任务
              setTimeout(function(){
                that.goUpgrade('pgy',that.changeVersionData.versionName)
              },1000);
            }
          }else if(name=='pt'){
            // 面板中选择平台
            this.searchPtVersions();
            // 获取下是否有进行中的任务，如果有，打开它
            var taskId = sessionStorage.getItem('upgradeTaskId');
            if( taskId == null || taskId == '' ){
            }else{
              // 有缓存的任务
              setTimeout(function(){
                that.goUpgrade('pt',that.changeVersionData.versionName)
              },1000);
            }
          }else{
            // 通过平台和守护进程，重新安装APK

          }
          
        },
        changeSearchFormDate(key, value) {
          console.log("changeSearchFormDate()", key );
          if(value!=null && value.length>1){
            if(value[0].length>10){
              value[0] = value[0].substring(0,10);
            }
            if(value[1].length>10){
              value[1] = value[1].substring(0,10);
            }
          }
          this.$set(this.searchForm, key, value)
        },
        resetSearchDate(param){
          console.log("resetSearchDate()");
        },
        // 保存声音设置
        gotoSaveVolume(){
          let that = this;
          var params = {
            deviceId : that.deviceData.deviceId,
            volume: that.volume,
            tVolume: that.tVolume,
            rVolume: that.rVolume,
          }
          saveDeviceVolume(params).then(function(rdata){
            var rs = rdata.data;
            if(rs.code==0){
              // 保存成功
              that.$message({
                type: 'success',
                message: "操作成功"
              });
              that.getDeviceDetailData();
              setTimeout(function(){
                that.volumeVisible = false;
              },300);
            }else{
                that.$message({
                type: 'error',
                message: rs.msg
                });
            }
          });

        },
        handleMapSelect(item) {
            if (item.value != '') {
            //清楚地图上的覆盖物
            this.gdmap.clearMap();
            console.log("搜索");
            this.gdmap.plugin('AMap.PlaceSearch', () => {
                let placeSearch = new AMap.PlaceSearch({
                pageSize: 10, // 单页显示结果条数
                pageIndex: 1, // 页码
                citylimit: false,  //是否强制限制在设置的城市内搜索
                map: this.gdmap, // 展现结果的地图实例
                // panel: "panel", // 结果列表将在此容器中进行展示。
                autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                });
                let that = this;
                //that.gdmap.setFitView();
                placeSearch.search(item.value, function (status, result) {
                    // 查询成功时，result即对应匹配的POI信息
                    console.log(result)
                    var pois = result.poiList.pois;
                    for (var i = 0; i < pois.length; i++) {
                        var poi = pois[i];
                        var marker = [];
                        marker[i] = new AMap.Marker({
                        position: poi.location,   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                        title: poi.name
                        });
                        // 将创建的点标记添加到已有的地图实例：
                        that.gdmap.add(marker[i]);
                    }
                });
            })
            }
        },
        keyupSearchValue(queryString, cb) {
            // 实例化Autocomplete
            var autoOptions = {
            //city 限定城市，默认全国
            //city: '全国'
            }
            var autoComplete = new AMap.Autocomplete(autoOptions);
            autoComplete.search(this.searchValue, function (status, result) {
            // 搜索成功时，result即是对应的匹配数据
            console.log("keyupSearchValue--result", result)
            let re = []
            if(result && result.tips){
              result.tips.forEach(item => {
                  re.push({value: item.name})
              })
            }
            cb(re)
            })
          
        },
        addTool() {
            AMap.plugin(['AMap.ToolBar'], () => {
            let toolbar = new AMap.ToolBar()
            this.gdmap.addControl(toolbar)
            })

        },
        //定位
        /* 拖拽选址 */
        regPositionPicker(that) {
            //方法一
            AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
                var positionPicker = new PositionPicker({
                    mode: 'dragMap',
                    map: that.gdmap,
                })
                positionPicker.on('success', function (positionResult) {
                    //经纬度
                    if(that.lastMapAddr==""){
                        that.lastMapAddr = positionResult.address;
                    }else{
                        if(that.lastMapAddr!=positionResult.address){
                            that.lastMapAddr = positionResult.address;
                            that.deviceData.loveAddr = positionResult.address;
                            that.deviceData.latitude = positionResult.position.toString().split(",")[1]
                            that.deviceData.longitude = positionResult.position.toString().split(",")[0]
                            that.keyLoves++;
                        }
                    }
                })
                positionPicker.start()
            })
        },
        // 去保存爱心港信息
        gotoSaveLoves(){
          let that = this;
          var params={
            loveName : that.deviceData.loveName,
            loveMobile : that.deviceData.loveMobile,
            loveUser : that.deviceData.loveUser,
            loveLogo : that.deviceData.loveLogo,
            loveAddr : that.deviceData.loveAddr,
            latitude : that.deviceData.lat,
            longitude : that.deviceData.lng,
            id : that.deviceData.id,
            deviceId : that.deviceData.deviceId,
            loveImgs : that.deviceData.loveImgs,
          };
          saveLoves(params).then(function(rdata){
            var rs = rdata.data;
            if(rs.code==0){
              // 保存成功
              that.$message({
                type: 'success',
                message: "操作成功"
              });
              that.getDeviceDetailData();
            }else{
              that.$message({
              type: 'error',
              message: rs.msg
              });
            }
          });
        },
        // 上传Logo
        goUploadLogo(param){
          const formData = new FormData();
          const data = {};
          formData.append('multipart', param.file);
          let _that = this;
          let loading = this.$loading({
            lock: true,
            text: '上传中，请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          uploadLoveHavenImg(formData)
          .then((res) => {
            var rs = res.data;
            loading.close();
            if(rs.code==0){
              var imgUrl = res.data.data;
              // _that.upgradeApkvnForm.url = imgUrl;
              _that.deviceData.loveLogo = imgUrl;
              _that.keyLoves++;
              console.log('uploadLoveHavenImg-imgUrl::',imgUrl);
              _that.$message.success('上传成功');
            }
          })
          .catch((res) => {
            loading.close();
            _that.$message({
              type: 'error',
              message: "文件上传出错了"
            });
          });
        },
        // 清除图标
        clearLoveLogo(){
          this.deviceData.loveLogo = "";
        },
        beforeUploadImgs(file){
          let _that = this;
          if(_that.loveImgs.length>=5){
            _that.$message({
              type: 'error',
              message: "最多5张照片"
            });
            return false;
          }
        },
        changeUploadImgs(){
          let _that = this;
          if(_that.loveImgs.length>=5){
            _that.$message({
              type: 'error',
              message: "最多5张照片"
            });
            return false;
          }
        },
        goUploadImgs(param){
          let _that = this;
          const formData = new FormData();
          const data = {};
          formData.append('multipart', param.file);
          let loading = this.$loading({
            lock: true,
            text: '上传中，请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          uploadLoveHavenImg(formData)
          .then((res) => {
            var rs = res.data;
            loading.close();
            if(rs.code==0){
              var imgUrl = res.data.data;
              // _that.upgradeApkvnForm.url = imgUrl;
              if(_that.deviceData.loveImgs==null){
                _that.deviceData.loveImgs="";
              }
              _that.deviceData.loveImgs = _that.deviceData.loveImgs + imgUrl + ";";
              var imgs = _that.deviceData.loveImgs.split(";");
              if(imgs.length>0){
                var last = imgs[imgs.length-1];
                if(last==null||last==""){
                  imgs.splice(imgs.length-1, 1);
                }
              }
              _that.loveImgs = imgs;
              _that.keyLoves++;
              console.log('uploadLoveHavenImg-imgUrl::',imgUrl);
              _that.$message.success('上传成功');
            }
          })
          .catch((res) => {
            loading.close();
            _that.$message({
              type: 'error',
              message: "文件上传出错了"
            });
          });
        },
        // 对图片排序操作
        leftLoveImg(idx){
          var preIdx = idx-1;
          if(preIdx>=0 && this.loveImgs.length>0 ){
            var preUrl = this.loveImgs[idx-1];
            var curUrl = this.loveImgs[idx];
            this.loveImgs[preIdx] = curUrl;
            this.loveImgs[idx] = preUrl;
          }
          var imgTmp="";
          var arr = this.loveImgs;
          for(var i=0;i<arr.length;i++){
            imgTmp = imgTmp + arr[i]+";";
          }
          this.deviceData.loveImgs = imgTmp;
          this.keyLoves = this.keyLoves +1;
        },
        // 移除数组中的图片
        removeLoveImg(idx){
          console.log("idx-close:", idx);
          if(this.loveImgs.length>0){
            this.loveImgs.splice(idx,1);
          }
          if(this.loveImgs.length>0){
            var imgTmp="";
            var arr = this.loveImgs;
            for(var i=0;i<arr.length;i++){
              imgTmp = imgTmp + arr[i]+";";
            }
            this.deviceData.loveImgs = imgTmp;
          }else{
            this.deviceData.loveImgs = "";
          }
          this.keyLoves = this.keyLoves +1;
        },
        // 显示为分钟
        toMinuteStr(second){
          if(second==null){
            return "--"
          }
          return Math.round(second/60);
        },
    }
  }
  </script>
<style lang="scss" scoped>
.el-form-item{
  margin-bottom: 5px;
}
</style>
<style >
.el-table th.el-table__cell {
  background-color: #f9f9f9; /* 你可以将这里设置为你想要的背景颜色 */
  color: #666; /* 你可以根据需要调整文字颜色 */
}

.tabHeader{
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.itemName{
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 4px;
  font-size: 12px;
  color: #909090;
  font-weight: 600;
}

.itemVal{
  line-height: 40px;
  font-size: 12px;
  color: #909090;
}

.operateDiv{
  width: 100%;
  height: 140px;
  border-radius: 10px;
  background-color: #f6f6f6;
}
.operateItem{
  height: 70px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #589ef8;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
}
.operateName{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  display: block;
  margin-top: 5px;
}

.gray {
  filter: grayscale(100%); /* 完全置灰 */
}
/** 图片旋转180度 */
.transform180{
  transform: rotate(180deg);
}

.upgradeDlg .el-dialog__body{
  padding-top: 0px;
  border-top: 1px solid #eeeeee;
}

#container{
  width: 100%;
  height: 500px;
}

.avatar-uploader{
  width: 58px;
  height: 28px;
  margin: 0 0 0 0;
  padding: 0;
  display: block;
}

.avatar-uploader .el-upload--picture-card{
  width:auto !important;
  height: auto !important;
  line-height: 20px !important;
  float: left;
  margin-top:5px;
}

.el-input{
  float: left;
}

.logoImgv{
  max-width: 100px;
  max-height: 80px;
}

.loveImgv :first-child{
  margin-left: 0px;
}

.loveImgIts{
  width: 100px;
  height: 100px;
  margin-left: 8px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
  float: left;
  border: 1px dashed red;
}

.loveImgIts img{
  max-width: 100%;
  max-height: 100%;
}

.lcb_l{
  width: 15px;
  height: 15px;
  border: 1px solid grey;
  float: left;
  display: inline-block;
  line-height: 15px;
  text-align: center;
  margin-left: 45px !important;
  margin-top: -80px;
  z-index: 999;
  cursor: pointer;
  position: absolute;
}

.lcb_x{
  width: 15px;
  height: 15px;
  border: 1px solid grey;
  float: left;
  display: inline-block;
  line-height: 15px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  z-index: 999;
  margin-left: 80px;
  margin-top: -80px;
}

</style>